import { queryOptions } from "@tanstack/react-query";
import { getStudentsOverview } from "#/modules/school.students/students.functions";
import type { TenantQueryKey } from "#/modules/util.fetch-client/tenant-query-key";
import type { StudentsSearch } from "./schema.search";

/**
 * Typed filter + pagination values for the students overview. Built from the page's typed
 * `Route.useSearch()` (component) or from the validated `location.search` (route loader) — both feed
 * the SAME query-options factory so the query key is identical for a given URL.
 */
export type StudentsOverviewFilters = StudentsSearch;

/** Follows the tenant segment — invalidate `[tenant, STUDENTS_OVERVIEW_QUERY_KEY]` to refresh every filter variant. */
export const STUDENTS_OVERVIEW_QUERY_KEY = "students-overview";

// See query.activities-overview for the SSR-without-hydration / staleTime rationale.
const OVERVIEW_STALE_TIME = 30_000;

export function studentsOverviewQueryOptions(
  tenant: TenantQueryKey,
  filters: StudentsOverviewFilters,
) {
  return queryOptions({
    // The server fn resolves the school from the page URL, not from `filters` — the tenant
    // segment is what keeps two schools' lists from colliding under one cache key.
    queryKey: [tenant, STUDENTS_OVERVIEW_QUERY_KEY, filters] as const,
    queryFn: () => getStudentsOverview({ data: filters }),
    staleTime: OVERVIEW_STALE_TIME,
  });
}
